import {
  AddCaseActionTypes,
  ADD_CASE_FAIL,
  ADD_CASE_LOADING,
  ADD_CASE_SUCCESS,
  AddCaseState,
  ADD_CASE_API_MSG,
  ADD_CASE_API_RES,
} from "./ActionTypes";
import { AddCaseResponse } from "./Model";

const initialStateEditPosts: AddCaseState = {
  loading: false,
  addCaseResponse: {} as AddCaseResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const addCaseReducer = (
  state = initialStateEditPosts,
  action: AddCaseActionTypes
): AddCaseState => {
  switch (action.type) {
    case ADD_CASE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_CASE_SUCCESS:
      return {
        ...state,
        addCaseResponse: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_CASE_FAIL:
      return {
        ...state,
        addCaseResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_CASE_API_MSG:
      return {
        ...state,
        addCaseResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_CASE_API_RES:
      return {
        ...state,
        addCaseResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
